import { ReportDefinition, SelectionDefinition, FavouriteDefinition } from 'app/types-shared';
import { updateSelectedReport } from './selected-report';

const updateReport = (
  report: ReportDefinition, 
  updatedFields: Partial<ReportDefinition>
) => {
  
  return {
    ...report,
    ...updatedFields
  };
};

export const updateGroupBy = (
  definition: FavouriteDefinition, 
  selectedGroupByFields: SelectionDefinition[],
  rollingAverage?: number
) => {
  
  const report = definition.reports.find(r => r.report.v === definition.selectedReport.v);
  let returnedReport: ReportDefinition = {
    ...report
  };

  if (!!selectedGroupByFields) {
    returnedReport = updateReport(returnedReport, {
      selections: selectedGroupByFields
    });
  }

  if (!!rollingAverage) {
    returnedReport = updateReport(returnedReport, { rollingAverage });
  } else {
    returnedReport = {
      ...returnedReport,
      rollingAverage: 0
    };
  }
  return updateSelectedReport(definition, returnedReport);
};
